import {format} from 'date-fns';

export class DownloadHelper {

  /**
   * data: array with values
   * columns: array with objects of type { title: '..', field: '..' }
  **/
  static download(filename: string, data:Array<any>, columns: Array<any>) {
    let csvRows = [];
    let header = [];
    for(let column of columns) {
      header.push(`"${column.title}"`);
    }
    csvRows.push(header.join(','));
    for (let row of data) {
      let csvRow = [];
      for (let column of columns) {
        let currentValue = row[column.field];
        if (currentValue instanceof Date)
          csvRow.push(format(currentValue, 'dd/MM/yyyy HH:mm:ss'));
        else
          csvRow.push(currentValue);
      }

      if (csvRow.length > 0) {
        csvRows.push(csvRow.join(','));
      }
    }

    let currentDate = format(new Date(), 'yyyyMMddHHmmss');
    let finalFilename = `${filename}_${currentDate}.csv`
    let blob = new Blob([csvRows.join('\r\n')], {type: 'text/csv'});

    if(window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, finalFilename);
    } else {
        let elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(blob);
        elem.download = finalFilename;        
        document.body.appendChild(elem)
        elem.click();        
        document.body.removeChild(elem);
    }
  }
  
}



// WEBPACK FOOTER //
// src/helpers/download.ts